<div class="banner">
  <div class="date flex">
    <div>
      Ficha:<span>{{ fichaTimeline.proposta.id }}</span>
    </div>

    <div>
      Iniciada:<span>{{
        fichaTimeline.proposta?.dataHoraEnvio | date: 'dd/MM/yyyy'
      }}</span
      >|<span>{{ fichaTimeline.proposta?.dataHoraEnvio | date: 'HH:mm' }}</span>
    </div>

    <div>
      <div *ngIf="fichaTimeline.proposta!.vendedor" class="user">
        <img
          class="user-photo"
          src="https://omnifacil2.omni.com.br/bs/images/user.png"
          alt="User Photo"
        />
        <span class="name">
          <span class="text-left">
            <span class="text-neutral px-0"
              >Razão Social:
              {{ fichaTimeline.proposta!.vendedor.nmLoja | titlecase }}</span
            ><br />
            <span class="text-neutral px-0"
              >Nome Fantasia:
              {{ fichaTimeline.proposta!.vendedor.nome | titlecase }}</span
            ><br />
            <ng-container *ngIf="fichaTimeline.proposta!.vendedor">
              Vendedor:
              {{
                (fichaTimeline.proposta!.vendedor.nomeVendedor | titlecase) ||
                  (fichaTimeline.proposta!.vendedor.emailVendedor | lowercase)
              }}
            </ng-container>
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="row client">
    <div class="col-xs-12">
      <span class="title">Cliente</span>
      <div class="content-name">
        <h2>{{ fichaTimeline.proposta?.cliente?.nomeCliente }}</h2>
        <app-sos-inverso
          [proposta]="fichaTimeline?.proposta"
          (sosEnviado)="onSosEnviado()"
          *ngIf="isShowEnviarSOS()"
        ></app-sos-inverso>
      </div>
      <span class="user-id"
        >CPF: {{ fichaTimeline.proposta?.cliente?.cpf | cpf }}</span
      >
    </div>
  </div>
</div>
